import { Component, ElementRef, OnInit, ViewChild, } from '@angular/core';
import { ServerConnectService } from '@app/core/services/server-connect.service';
import {
  BaronConfig,
  CircleOptions,
  DepartureAirport,
  LatlngArr,
  LineSymbolForGCD,
  MapIcon,
  MapStyle,
  NfpWmsConfig,
  TripRoute,
} from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { CommonService } from '@app/shared/services/common.service';
import { MapConfig } from '../../../../environments/environment';
import { AirportdetailscardComponent } from '../airportdetailscard/airportdetailscard.component';
import { layerList } from '@app/shared/constants/constant';
declare var google: any;
@Component({
    selector: 'app-route-map',
    templateUrl: './route-map.component.html',
    styleUrls: ['./route-map.component.scss'],
    standalone: false
})
export class RouteMapComponent implements OnInit {
  @ViewChild('routeMap', { static: false }) public mapElement: ElementRef;
  public map: any;
  private circleList = new Array();
  private layer = "none";

  constructor(
    public flightPlanService: FlightPlanService,
    public serverConnectService: ServerConnectService,
    public commonService: CommonService
  ) {
    this.flightPlanService.emiterToSubject.subscribe((res: TripRoute) => {
      this.loadMap(res);
      this.drawAdequateAirportCircle(res);
    })
  }
  public ngOnInit() {
  }
  public ngAfterViewInit() {
  }
  public async loadMap(res: TripRoute) {
    if (res) {
      const corordinatearray = [];
      const lengthofArr = res.latlngArr.length;
      const middleLatLong = res.latlngArr[Math.round(lengthofArr / 2.5)];
      res.latlngArr.forEach(
        (element) => {
          const latlong = {
            lat: element.Latitude,
            lng: element.Longitude,
            title: element.Designator,
          };
          corordinatearray.push(latlong);
        },
      );
      const start = res.latlngArr[0] as LatlngArr;
      const end = res.latlngArr[lengthofArr - 1] as LatlngArr;
      const latLng = new google.maps.LatLng(
        middleLatLong.Latitude,
        middleLatLong.Longitude,
      );
      const configuredMapId =
        MapConfig.googleMapId && MapConfig.googleMapId !== 'DEMO_MAP_ID'
          ? MapConfig.googleMapId
          : '';
      const mapOptions: any = {
        center: latLng,
        maxZoom: 9,
        zoom: (await this.flightPlanService.getZoom(start.Latitude, start.Longitude, end.Latitude, end.Longitude) - 0.25),
        tilt: 45,
        scaleControl: false,
        navigationControl: false,
        streetViewControl: false,
        disableDefaultUI: true,
      };
      if (configuredMapId) {
        mapOptions.mapId = configuredMapId;
      }
      if (!configuredMapId) {
        const politicalStyleOverrides = [
          { featureType: 'road', elementType: 'all', stylers: [{ visibility: 'off' }] },
          { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
        ];
        mapOptions.styles = [...MapStyle, ...politicalStyleOverrides];
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      await this.drawRoute(corordinatearray, "to");
      await this.drawGcdLine(start, end);
      await this.addMarkerOnMap(start.Designator, { lat: +start.Latitude, lng: +start.Longitude });
      await this.addMarkerOnMap(end.Designator, { lat: +end.Latitude, lng: +end.Longitude });
      await this.drawAlternateRoute(res);
      this.setLayer();
      const centerControlDiv = document.createElement("div");
      const centerControl = this.centerControl(centerControlDiv, this.map);
      this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
        centerControlDiv,
      );
    }
  }
  public async drawAlternateRoute(res: TripRoute) {
    if (res.alternate) {
      await this.sendToDrawAlternate(res.alternate, "alt1");
    }
    if (res.alternate2) {
      await this.sendToDrawAlternate(res.alternate2, "alt2");
    }
  }
  public async sendToDrawAlternate(alternate, type: string) {
    const alt1LatLongArr = alternate.latlngArr.map((latLngPair: LatlngArr) => {
      return { lat: latLngPair.Latitude, lng: latLngPair.Longitude, title: latLngPair.Designator };
    });
    this.drawRoute(alt1LatLongArr, type);
    const endCordinates = alt1LatLongArr[alt1LatLongArr.length - 1];
    this.addMarkerOnMap(alternate.Airport.AirportICAOCode, { lat: +endCordinates.lat, lng: +endCordinates.lng })
  }
  public setLayer() {
    const airacCyleIndex = this.flightPlanService.getAiracCycle();
    const that = this;
    this.map.overlayMapTypes.clear();
    if (this.layer == 'none') {
    } else if (this.layer == 'weather') {
      const mapType = new google.maps.ImageMapType({
        getTileUrl(coord, zoom) {
          // http://code.google.com/apis/maps/documentation/javascript/maptypes.html#ProjectionTileUsage

          // Our grid is square, so this represents either the number of tiles high or wide.
          const numTiles: any = 1 < zoom;

          // Don't wrap tiles vertically.
          if (coord.y < 0 || coord.y >= numTiles) {
            return null;
          }

          // Wrap tiles horizontally. Part of this looks redundant, but it is NOT!
          // That part is needed to prevent requests for negative numbered tiles.
          const x = ((coord.x % numTiles) + numTiles) % numTiles;

          // Google Maps considers the TopLeft grid tile to be (0, 0), while TMS
          // considers the Bottomleft grid tile to be (0, 0).
          const y = numTiles - coord.y - 1;

          // Url of overlay tile
          const baseUrl =
            BaronConfig.base_url +
            '/' +
            BaronConfig.key +
            '/tms/1.0.0/' +
            BaronConfig.product +
            '+' +
            BaronConfig.configuration +
            '+' +
            this.flightPlanService.get_baron_time() +
            '/' +
            zoom +
            '/' +
            x +
            '/' +
            y +
            '.png?' +
            this.flightPlanService.get_signature();
          return baseUrl;
        },
        tileSize: new google.maps.Size(256, 256),
        opacity: 0.7,
        isPng: true,
      });
      this.map.overlayMapTypes.push(mapType);
    } else if (
      this.layer == 'sigwx' ||
      this.layer == 'wx' ||
      this.layer == 'winds' ||
      this.layer == 'firs' ||
      this.layer == 'airports'
    ) {
      const mapObject = this.map;
      const currentLayer = this.layer;
      const weatherLayer = new google.maps.ImageMapType({
        getTileUrl(coord, zoom) {
          const zfactor = Math.pow(2, zoom);
          const proj = mapObject.getProjection();

          const top = proj.fromPointToLatLng(
            new google.maps.Point(
              (coord.x * 256) / zfactor,
              (coord.y * 256) / zfactor
            )
          );
          const bot = proj.fromPointToLatLng(
            new google.maps.Point(
              ((coord.x + 1) * 256) / zfactor,
              ((coord.y + 1) * 256) / zfactor
            )
          );

          const bbox = `${top.lng()},${bot.lat()},${bot.lng()},${top.lat()}`;

          let params = 'bbox=' + bbox;
          params += '&layer=' + currentLayer;

          return (
            that.serverConnectService.getActualUrl(
              NfpWmsConfig.WMSendpoint,
              'api/v1'
            ) +
            '/' +
            params
          );
        },
        tileSize: new google.maps.Size(256, 256),
        isPng: true,
      });
      this.map.overlayMapTypes.push(weatherLayer);
    } else {
      const hiOverlay = new google.maps.ImageMapType({
        getTileUrl(coord, zoom) {
          return (
            'https://t.skyvector.com/4WFYbW00p0mIz9kG/' +
            that.layer +
            '/' +
            airacCyleIndex +
            '/' +
            zoom +
            '/' +
            coord.x +
            '/' +
            coord.y +
            '.jpg'
          );
        },
        tileSize: new google.maps.Size(256, 256),
      });
      this.map.overlayMapTypes.insertAt(0, hiOverlay);
    }
  }
  public async drawRoute(alt1LatLongArr, type: string) {
    await new google.maps.Polyline({
      map: this.map,
      path: alt1LatLongArr,
      icons: [
        MapIcon,
      ],
      strokeColor: await this.flightPlanService.getLineColorForMap(type),
      strokeOpacity: 1.0,
    });
  }
  public async drawGcdLine(start: LatlngArr, end: LatlngArr) {
    const latlngobj = [
      { lat: start.Latitude, lng: start.Longitude },
      { lat: end.Latitude, lng: end.Longitude },
    ];
    const departure = new google.maps.LatLng(start.Latitude, start.Longitude);
    const arrival = new google.maps.LatLng(end.Latitude, end.Longitude);
    const line = new google.maps.Polyline({
      path: latlngobj,
      strokeColor: "orange",
      strokeOpacity: 0,
      geodesic: true,
      icons: [
        {
          icon: LineSymbolForGCD,
          offset: 0,
          repeat: "13px",
        },
      ],
      map: this.map,
    });
    let step = 0;
    const numSteps = 300;
    const timePerStep = 5;
    const interval = setInterval(() => {
      step += 1;
      if (step > numSteps) {
        clearInterval(interval);
      } else {
        const interpolate = new google.maps.geometry.spherical.interpolate(
          departure,
          arrival,
          step / numSteps,
        );
        line.setPath([departure, interpolate]);
      }
    }, timePerStep);
  }
  public addMarkerOnMap(ICAOCode: string, latLng) {
    const that: any = this;
    const hasValidMapId = !!(MapConfig.googleMapId && MapConfig.googleMapId !== 'DEMO_MAP_ID');
    const AdvancedMarkerElement = google.maps?.marker?.AdvancedMarkerElement;
    if (hasValidMapId && AdvancedMarkerElement) {
      const markerContent = document.createElement('div');
      markerContent.style.display = 'flex';
      markerContent.style.flexDirection = 'column';
      markerContent.style.alignItems = 'center';
      markerContent.innerHTML = `
        <img src="/assets/icon/airport-icon.svg" width="28" height="28" alt="airport-marker" />
        <span style="font-size:10px;font-weight:600;color:#2a2a2a;background:#fff;padding:1px 4px;border-radius:8px;margin-top:2px;">${ICAOCode}</span>
      `;
      this.createAdvancedMarker(AdvancedMarkerElement, {
        map: this.map,
        position: latLng,
        content: markerContent,
        title: ICAOCode,
      });
      return;
    }
    this.addOverlayMarker(latLng, ICAOCode);
  }
  private addOverlayMarker(position: { lat: number; lng: number }, label: string): void {
    class AirportOverlay extends google.maps.OverlayView {
      private div: HTMLDivElement | null = null;
      constructor(private pos: { lat: number; lng: number }, private text: string) {
        super();
      }
      public onAdd() {
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.style.transform = 'translate(-50%, -100%)';
        this.div.style.display = 'flex';
        this.div.style.flexDirection = 'column';
        this.div.style.alignItems = 'center';
        this.div.innerHTML = `
          <img src="/assets/icon/airport-icon.svg" width="24" height="24" alt="airport-marker" />
          <span style="font-size:10px;font-weight:600;color:#2a2a2a;background:#fff;padding:1px 4px;border-radius:8px;margin-top:2px;">${this.text}</span>
        `;
        const panes = this.getPanes();
        panes?.overlayMouseTarget.appendChild(this.div);
      }
      public draw() {
        if (!this.div) {
          return;
        }
        const projection = this.getProjection();
        const pixel = projection?.fromLatLngToDivPixel(new google.maps.LatLng(this.pos.lat, this.pos.lng));
        if (!pixel) {
          return;
        }
        this.div.style.left = `${pixel.x}px`;
        this.div.style.top = `${pixel.y}px`;
      }
      public onRemove() {
        this.div?.remove();
        this.div = null;
      }
    }
    const overlay = new AirportOverlay(position, label);
    overlay.setMap(this.map);
  }

  private createAdvancedMarker(AdvancedMarkerElement: any, options: any): any {
    return new AdvancedMarkerElement(options);
  }
  public async drawCircle(circleObject: DepartureAirport, seDistance: number) {
    const ref = circleObject.ReferencePosition;
    const that: any = this;
    const latLng = { lat: +ref.Latitude, lng: +ref.Longitude };
    CircleOptions.map = this.map;
    CircleOptions.center = latLng;
    CircleOptions.strokeColor = await this.flightPlanService.getRandomColor();
    CircleOptions.radius = seDistance * 1852;
    const circle = await new google.maps.Circle({
      strokeColor: await this.flightPlanService.getRandomColor(),
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: "#edf7f0",
      fillOpacity: 0.4,
      map: this.map,
      center: latLng,
      radius: seDistance * 1852,
    });
    this.circleList.push(circle);
    await this.addMarkerOnMap(circleObject.ICAOCode, latLng);
  }
  public async drawAdequateAirportCircle(res: TripRoute) {
    if (res) {
      this.deleteCircle();
      res.AdequateAirport.forEach((element: DepartureAirport) => {
        this.drawCircle(element, 320);
        const etopsComputedMinutes = this.flightPlanService.tripRouteData?.requestInputParam?.ReceivedData?.etopsMinutes;
        const seSpeed = this.flightPlanService.tripRouteData.AircraftDetail.SingleCruiseSpeed;
        const aircraftDefaultSeDistance = this.flightPlanService.tripRouteData.AircraftDetail.SEDistance;
        const seDistance = etopsComputedMinutes ?  this.computeSEDistance(Number(etopsComputedMinutes), seSpeed) : Number(aircraftDefaultSeDistance)
        this.drawCircle(element, seDistance);
      });
    }
  }
  public deleteCircle() {
    if (this.circleList && this.circleList.length > 0) {
      // this.circleList.forEach((circle) => circle.remove());
    }
  }
  public showAdequateAirport(ICAO: string, type: string, airportinfo: DepartureAirport) {
    this.commonService.showCommonModal(AirportdetailscardComponent, { airportInfo: airportinfo }, 'airportDetails')
  }

  public centerControl(controlDiv, map) {
    // Set CSS for the control border.
    const controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#f6f6ff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.color = "#727272"
    controlUI.style.cursor = "pointer";
    controlUI.style.margin = "10px";
    let layers = '';
    layerList.forEach(element => {
      layers += `<option value=${element?.value}
        ${ this.layer == element?.value ? " selected" : "" } > ${element?.label} </option>`
    });
    controlUI.innerHTML =`<select id='layer'style='background-color:#f6f6ff' class='layer-select'>
        ${layers}
      </select>`;
      // <option value='hi'
      // ${this.layer == "hi" ? " selected" : ""} >HI</option>
      // <option value='lo'
      // ${this.layer == "lo" ? " selected" : ""} >LOW</option>
      // <option value='vfr'
      // ${this.layer == "vfr" ? " selected" : ""} >VFR</option>
      // <option value='wx'
      // ${this.layer == "wx" ? " selected" : ""} >SIGMET</option>
      // <option value='sigwx'
      // ${this.layer == "sigwx" ? " selected" : ""} >SigWx</option>
      // <option value='winds'
      // ${this.layer == "winds" ? " selected" : ""} >Winds</option>
      // <option value='firs'
      // ${this.layer == "firs" ? " selected" : ""} >Firs</option>
      // <option value='airports'
      // ${this.layer == "airports" ? " selected" : ""}>Airports</option>
      // <option value='none'
      // ${this.layer == "none" ? " selected" : ""} >None</option>
    controlDiv.appendChild(controlUI);
    // Set CSS for the control interior.
    // Setup the click event listeners: simply set the map to Chicago.
    const that = this;
    controlUI.addEventListener("change", () => {
      const layerElement = (document.getElementById(
        "layer",
      ) as HTMLInputElement).value;
      that.layer = layerElement;
      that.setLayer();
    });
  }

  private computeSEDistance(speed,time){
    return Math.round(speed * time /60 );
  }

}
